import { DIALOG_ALERT_I18N_SUBNAMESPACE } from "../lib/constants";
import { DialogAlertI18nResource } from "../types";

export const defaultResource: DialogAlertI18nResource = {
  sharedui: {
    translation: {
      [DIALOG_ALERT_I18N_SUBNAMESPACE]: {
        cancel: "Cancel",
        close: "Close",
        "success.saved": {
          title: "Successfully",
          description: "Data has been successfully saved"
        },
        "success.deleted": {
          title: "Successfully",
          description: "Data has been successfully deleted"
        },
        "success.removed": {
          title: "Successfully",
          description: "Data has been successfully removed"
        },
        "error.api_db_error": {
          title: "API/Database Error",
          description: "Failed to connect to the system. Please check API or database connection."
        },
        "error.permission_denied": {
          title: "Permission Denied",
          description: "You do not have permission to delete this data.",
          confirm_text: "Discard"
        },
        "error.session_expired": {
          title: "Session Expired",
          description: "Your session has expired or you have been logged out. Please sign in again.",
          confirm_text: "Logout"
        },
        "error.user_not_found": {
          title: "User Not Found",
          description: "The system could not locate the user account.",
          confirm_text: "Logout"
        },
        "error.data_not_found": {
          title: "Data Not Found",
          description: "The data has already been deleted or does not exist in the system."
        },
        "error.data_restrict_editing": {
          title: "Data Status Restricts Editing",
          description: "Data status does not allow editing."
        },
        "error.network_timeout_error": {
          title: "Network Error / Timeout",
          description:
            "The system could not connect to the network or the request took too long to process."
        },
        "error.queue_full": {
          title: "Queue Full",
          description: "The notification queue has reached its limit. Please try again later."
        },
        "error.invalid_data_format": {
          title: "Invalid Data Format",
          description: "Data creation failed due to invalid or incorrectly formatted data."
        },
        "error.data_linked_to_system_data": {
          title: "Data Linked to System Data",
          description: "Cannot delete data because they are linked to existing system data."
        },
        "error.pending_workflow_conflict": {
          title: "Pending Workflow Conflict ",
          description:
            "The data is currently involved in a pending workflow or approval process and cannot be deactivated."
        },
        "error.invalid_incomplete_data": {
          title: "Invalid or Incomplete Data",
          description: "Data status cannot be changed due to incomplete or invalid information."
        },
        "error.client_side_error": {
          title: "Client-Side Error",
          description: "An error occurred on the client side. Please refresh the page or try again."
        },
        "error.system_limitation": {
          title: "System Limitation",
          description:
            "The search cannot be completed due to system limitations. Please simplify your query."
        },
        "error.timeout": {
          title: "Timeout",
          description: "Request failed due to a system error or timeout. Please try again."
        },
        "error.duplicate_data": {
          title: "Duplicate Data",
          description: "The data you entered already exists in the system."
        },
        "error.something_went_wrong": {
          title: "Something Went Wrong",
          description: "An unknown error occurred."
        },
        "confirm.delete": {
          title: "Confirmation",
          description: "Are you sure you want to delete this item?",
          confirm_text: "Delete"
        },
        "confirm.inactive": {
          title: "Confirmation",
          description: "Are you sure you want to inactive this item?",
          confirm_text: "Inactive"
        },
        "confirm.active": {
          variant: "confirm-green",
          title: "Confirmation",
          description: "Are you sure you want to active this item?",
          confirm_text: "Active"
        },
        "confirm.leave_page": {
          title: "Confirmation",
          description: "Unsaved changes. Do you want to leave this page?",
          confirm_text: "Leave"
        },
        "confirm.remove": {
          title: "Confirmation",
          description: "Are you sure you want to remove this item?",
          confirm_text: "Remove"
        },
        "confirm.logout": {
          title: "Confirmation",
          description: "Do you want to log out?",
          confirm_text: "Logout"
        }
      }
    }
  }
};
